export default __webpack_public_path__ + "static/media/vector.bab565da.svg";